import {RefraModalProvider} from './RefraModalProvider'

interface AppProvidersProps {
  children: React.ReactNode
}

export const AppProviders: React.FC<AppProvidersProps> = ({children}) => {
  return <RefraModalProvider>{children}</RefraModalProvider>
}
